import { cn } from "@devhop/ui";
import type { ReactNode } from "react";

type OrderDetailActionsProps = {
  children: ReactNode;
  className?: string;
};

export function OrderDetailActions({
  children,
  className,
}: OrderDetailActionsProps) {
  return (
    <div
      className={cn(
        "rounded-xl border bg-card p-4 shadow-sm",
        className,
      )}
    >
      <h3 className="mb-3 font-heading font-semibold text-base">ການດຳເນີນການ</h3>
      <div className="space-y-2">{children}</div>
    </div>
  );
}

export function OrderDetailActionGroup({
  title,
  children,
}: {
  title?: string;
  children: ReactNode;
}) {
  return (
    <div className="space-y-2">
      {title && (
        <div className="pt-1 font-medium text-muted-foreground text-xs uppercase tracking-wide">
          {title}
        </div>
      )}
      <div className="space-y-2">{children}</div>
    </div>
  );
}
